import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, Button, Box, InputAdornment } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./CreateEngineer.css"; // Uses same style as CreateSite.css
import axios from "axios";
import apiService from "../../utils/apiservice";



const CreateSupervisorEngineer = () => {
    const [engineerData, setEngineerData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone_no: "",
    });

    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const nameRegex = /^[A-Za-z]{2,10}$/;
    const emailRegex =
  /^[a-z0-9]+([._%+-]?[a-z0-9]+)*@[a-z0-9-]+\.[a-z]{2,}$/;
    const phoneRegex = /^[6-9]\d{9}$/;


    const API_URL = process.env.REACT_APP_API_DJANGO_URL;




    // Generates strong password
    // const generatePassword = (length = 10) => {
    //     const chars =
    //         "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    //     let password = "";
    //     for (let i = 0; i < length; i++) {
    //         password += chars.charAt(Math.floor(Math.random() * chars.length));
    //     }
    //     return password;
    // };

    const validateForm = () => {
        const tempErrors = {};

        const firstName = engineerData.first_name.trim();
        const lastName = engineerData.last_name.trim();
        const email = engineerData.email.trim();
        const phone = engineerData.phone_no.trim();

        // First Name
        if (!firstName) {
            tempErrors.first_name = "First name is required";
        } else if (!nameRegex.test(firstName)) {
            tempErrors.first_name = "Only alphabets (2–10), no spaces";
        }

        // Last Name
        if (!lastName) {
            tempErrors.last_name = "Last name is required";
        } else if (!nameRegex.test(lastName)) {
            tempErrors.last_name = "Only alphabets (2–10), no spaces";
        }

        // Email
        if (!email) {
            tempErrors.email = "Email is required";
        } else if (!emailRegex.test(email)) {
            tempErrors.email = "Invalid email format";
        }

        // Phone
        if (!phone) {
            tempErrors.phone_no = "Phone number is required";
        } else if (!phoneRegex.test(phone)) {
            tempErrors.phone_no = "Must start from 6–9 and be 10 digits";
        }

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };



    const handleChange = (e) => {
        let { name, value } = e.target;

        // ✅ Names → only alphabets
        if (name === "first_name" || name === "last_name") {
            value = value.replace(/[^A-Za-z]/g, "");
        }

        // ✅ Email → remove starting spaces
        if (name === "email") {
            value = value.replace(/^\s+/, "");
        }

        // ✅ Phone → only digits + max 10
        if (name === "phone_no") {
            value = value.replace(/\D/g, "").slice(0, 10);
        }

        setEngineerData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // ✅ Real-time validation
        let error = "";

        if (name === "first_name" || name === "last_name") {
            if (!value) {
                error = `${name === "first_name" ? "First" : "Last"} name is required`;
            } else if (!nameRegex.test(value)) {
                error = "Only alphabets (2–10), no spaces";
            }
        }

        if (name === "email") {
            if (value && !emailRegex.test(value)) {
                error = "Invalid email";
            }
        }

        if (name === "phone_no") {
            if (value && !phoneRegex.test(value)) {
                error = "Must start from 6–9 and be 10 digits";
            }
        }

        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));
    };




    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            const token = localStorage.getItem("accessToken");
            const customerId = localStorage.getItem("customer_id");

            if (!token) {
                toast.error("No token found! Please login first.");
                return;
            }

            if (!customerId) {
                toast.error("Customer ID missing!");
                return;
            }

            // ✅ Generate password dynamically
            // const password = generatePassword(10);

            const payload = {
                ...engineerData,
                customer_id: customerId,
                // password: password,
            };


            const response = await apiService.post(
                "/api/create_site_engineer_by_customer/",
                payload
            );
            console.log("Engineer created:", response.data);

            // ✅ Show password in toast (optional)
            toast.success("Engineer Created Successfully");

            // Reset form
            setEngineerData({
                first_name: "",
                last_name: "",
                email: "",
                phone_no: "",
            });

            setErrors({});
        } catch (error) {
            console.error("Error:", error.response?.data || error.message);

            toast.error(
                error.response?.data?.error || "Failed to create engineer"
            );
        }
    };

    return (
        <Box component="form" className="create-site-form-container" onSubmit={handleFormSubmit}>

            <Grid container spacing={3}>

                {/* First Name */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        className="create-site-input"
                        label="First Name"
                        name="first_name"
                        value={engineerData.first_name}
                        onChange={handleChange}
                        required
                        error={!!errors.first_name}
                        helperText={errors.first_name || ""}

                    />
                </Grid>

                {/* Last Name */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        className="create-site-input"
                        label="Last Name"
                        name="last_name"
                        value={engineerData.last_name}
                        onChange={handleChange}
                        required
                        error={!!errors.last_name}
                        helperText={errors.last_name || ""}
                    />
                </Grid>

                {/* Email */}
                <Grid item xs={12}>
                    <TextField
                        className="create-site-input"
                        label="Email Address"
                        name="email"
                        type="email"
                        value={engineerData.email}
                        onChange={handleChange}
                        inputProps={{
                            style: { textTransform: "lowercase" }
                        }}
                        required
                        error={!!errors.email}
                        helperText={errors.email || ""}

                    />
                </Grid>

                {/* Phone Number */}
                <Grid item xs={12}>
                    <TextField
                        className="create-site-input"
                        label="Phone Number"
                        name="phone_no"
                        value={engineerData.phone_no}
                        onChange={handleChange}
                        required
                        error={!!errors.phone_no}
                        helperText={errors.phone_no || ""}

                    />
                </Grid>

            </Grid>

            <Box className="submit-btn-wrapper" display="flex" gap={2} mt={3}>
                <Button
                    type="button"
                    variant="outlined"
                    className="submit-btn cancel-btn"
                    onClick={() => {
                        setEngineerData({ first_name: "", last_name: "", email: "", phone_no: "" });
                        setErrors({});
                        navigate("/dashboard");
                    }}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    className="submit-btn"
                >
                    Create Engineer
                </Button>
            </Box>

            <ToastContainer position="top-right" autoClose={3000} />
        </Box>
    );
};

export default CreateSupervisorEngineer;